import { get } from 'lodash';
import { splitPlatform } from '../Translations/TranslationComponent';

export const js2xml = (js, language) => {
  const xmlLines = js.map((string) => {
    const engTrans = string.translations.find((trans) => trans.lang === 'en');
    const isUpperCase = engTrans !== null && engTrans.content !== null && engTrans.content.toUpperCase() === engTrans.content;
    const [value] = string.translations.map((trans) =>
      trans.lang === language
        ? `\t\t<string ${string.translatable === false ?
          'translatable="false" ' : ''}name="${splitPlatform(string.identifier)}">${trans.content ?
          (isUpperCase ? trans.content.toUpperCase() : trans.content) :
          engTrans.content}</string>\n` // defaults to english translation if there isn't one
        : false).filter((item) => !!item);
    if (string.comment) {
      return `\t\t<!-- ${string.comment} -->\n${value}`;
    }
    return value;
  });

  return `<?xml version="1.0" encoding="utf-8"?>\n\t<resources>\n${xmlLines.join('')}\t</resources>`;
};

const getSource = (translations) => {
  const trans = translations.find((trans) => trans.lang === 'en'); // eslint-disable-line no-shadow
  if (get(trans, 'content')) {
    return get(trans, 'content');
  }
  return '';
};

export const js2xliff = (js, language) => {
  // console.log('minGroipBY', groupByFile(js));
  const obj = groupByFile(js);
  const groupPerFile = Object.keys(obj).reduce((res, curr) => { res.push(obj[curr]); return res; }, []);
  console.log(groupPerFile);

  const xmlFiles = groupPerFile.map((files) => {
    // console.log(files);
    const fileMeta = files[0].meta.file;
    const headerMeta = files[0].meta.header;

    const oneTab = '\t';
    const twoTab = '\t\t';
    const threeTab = '\t\t\t';
    const fourTab = '\t\t\t\t';


    const phrases = files.map((phrase) => {
      const engTrans = phrase.translations.find((trans) => trans.lang === 'en');
      const isUpperCase = engTrans !== null && engTrans.content.toUpperCase() === engTrans.content;
      const [value] = phrase.translations.map((trans) =>
        trans.lang === language && trans.content
          ? `${fourTab}<source>${getSource(phrase.translations)}</source>${language !== 'en' ? `\n${fourTab}<target>${isUpperCase ? trans.content.toUpperCase() : trans.content}</target>` : ''}\n${fourTab}<note>${phrase.comment}</note>`
          : false).filter((item) => !!item);
      if (!value) {
        return null;
      }
      return `${threeTab}<trans-unit id="${splitPlatform(phrase.identifier).split('@@@@').slice(1).join('')}">\n${value}\n${threeTab}</trans-unit>\n`;
    }).filter((item) => !!item);


    return `${oneTab}<file original="${fileMeta.original}" datatype="${fileMeta.datatype}" source-language="${fileMeta['source-language']}" target-language="${language}">\n${twoTab}<header>\n${threeTab}<tool tool-id="${headerMeta['tool-id']}" tool-name="${headerMeta['tool-name']}" tool-version="${headerMeta['tool-version']}" build-num="${headerMeta['build-num']}" />\n${twoTab}</header>\n${twoTab}<body>\n${phrases.join('')}${twoTab}</body>\n${oneTab}</file>\n`;
  });

  return `<?xml version="1.0" encoding="UTF-8"?>\n<xliff xmlns="urn:oasis:names:tc:xliff:document:1.2" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="1.2" xsi:schemaLocation="urn:oasis:names:tc:xliff:document:1.2 http://docs.oasis-open.org/xliff/v1.2/os/xliff-core-1.2-strict.xsd">\n${xmlFiles.join('')}</xliff>`;
};

const groupByFile = (arr) => arr.reduce((acc, curr) => {
  const key = curr.meta.file.original;

  if (acc[key]) {
    acc[key].push(curr);
  } else {
    acc[key] = [curr];
  }
  return acc;
}, {});
